<template>
  <div>
    <el-card shadow="never" style="margin-top: 10px">
      <el-form :model="busData" label-width="150px" >
        <el-row :gutter="20">
          <el-form-item :span="4" label="试卷模板名称:" >
            <el-input v-model="busData.name" class="form-item" placeholder="试卷模板名称" clearable="true"
                      filterable="true">
            </el-input>
          </el-form-item>

          <el-form-item span="4" label="考试时长(分钟):" >
            <el-input-number v-model="busData.time" :min="0" class="form-item" placeholder="考试时长" clearable="true"
                             filterable="true" >
            </el-input-number>
          </el-form-item>
        </el-row>

        <el-row :gutter="20">
          <el-form-item span="4" label="总分:" >
            <el-input-number v-model="busData.total_score" :min="0" :max="999" disabled class="form-item" placeholder="总分" clearable="true"
                             filterable="true">
            </el-input-number>
          </el-form-item>

          <el-form-item span="4" label="及格分数:" >
            <el-input-number v-model="busData.pass_score" :min="0" @change="passScore" class="form-item" placeholder="及格分数" clearable="true"
                             filterable="true">
            </el-input-number>
            <el-button style="margin-left: 20px" @click="addOneQuestion()">添加出题行</el-button>
          </el-form-item>
        </el-row>


      </el-form>

      <el-row class="box">
        <el-col :span="7">{{ $t('exam.catalog') }}</el-col>
        <el-col :span="4">{{ $t('exam.question_type') }}</el-col>
        <el-col :span="4">{{ $t('exam.score') }}</el-col>
        <el-col :span="4">{{ $t('exam.question_number') }}</el-col>
        <el-col :span="4">{{ $t('exam.level') }}</el-col>
        <el-col :span="1"></el-col>
      </el-row>

      <div style="height:240px;overflow-y: auto;overflow-x: hidden">
        <el-row v-for="item in busData.itemList" :key="item.id" class="row" :gutter="25">
          <el-col :span="7">
            <el-cascader v-model="item.catalog" :options="catalogWithQuestion" style="width: 100%"
                         @change="onCatalogSelect(item)" :props="props"
                         :show-all-levels="false" placeholder="问题知识分类"/>
          </el-col>
          <el-col :span="4">
            <el-select v-model="item.question_type"  style="width: 100%" @change="changeQuestionNumber()" placeholder="问题题型">
              <el-option v-for="item in typeWithQuestion" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-input-number v-model="item.score" :min="0" @change="changeQuestionNumber()" placeholder="分值" style="width: 100%"></el-input-number>
          </el-col>
          <el-col :span="4">
            <el-input-number v-model="item.question_number" :min="0" @change="changeQuestionNumber()" placeholder="数量" style="width: 100%"></el-input-number>
          </el-col>
          <el-col :span="4">
            <el-select v-model="item.level"   placeholder="难度" style="width: 120px">
              <el-option v-for="item in levelWithQuestion" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-col>
          <div class="close" @click="removeOneQuestion(item.id)">
            <el-icon :span="1">
              <ElIconClose></ElIconClose>
            </el-icon>
          </div>
        </el-row>
      </div>

      <el-row style="margin-top: 15px">
        <el-col :span="9">
          <el-input type="textarea" class="exam-remark" v-model="busData.remark" placeholder="试卷模板备注" style="width: 100%"
                    :autosize="true"></el-input>
        </el-col>
      </el-row>

      <el-row>
        <el-button type="primary" style="width: 500px;;margin-top: 20px" @click="editExam" :loading="loading">保存</el-button>
      </el-row>

    </el-card>
  </div>
</template>

<script>
import {nanoid} from 'nanoid'

export default {
  name: "ExamTemplateUpdate",
  inject: ['$fn'],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      props: {
        expandTrigger: 'hover',
        value: 'id',
        label: 'name',
        emitPath:false,
        checkStrictly: true
      },
      priceTips: false,
      dialogFormVisible: false,
      busData: {
        total_score: 0,
        time: '',
        name: '',
        pass_score:'',
        catalog:'',
        question_type:'',
        remark: '',
        id: '',
        itemList: [],
      },
      catalogWithQuestion: [],
      examList: [],
      loading: false,
      examNameList:[],
      examTimeList:[],
      examPassScoreList:[]
    }
  },
  computed: {
    typeWithQuestion() {
      return this.$store.getters['core/getDictList']('question_type');
    },
    levelWithQuestion() {
      return this.$store.getters['core/getDictList']('question_level');
    },
  },
  created() {
    this.getCatalogWithQuestion()
    this.getExamTemplateWithDetail()
  },
  methods: {
    passScore(){
      if (this.busData.pass_score > this.busData.total_score){
        this.busData.pass_score = this.busData.total_score
        return this.$message.error("及格分数不能大于总分")
      }
    },
    async getExamTemplateWithDetail() {
      this.busData.id = this.parentData.id
      this.busData.name = this.parentData.name
      this.busData.time = this.parentData.time
      this.busData.pass_score = this.parentData.pass_score
      this.busData.remark = this.parentData.remark
      this.busData.total_score = this.parentData.total_score
      let params = {template_id:this.parentData.id}
      let templateData = await this.$http('ihtExamTemplateService.getExamTemplateWithDetail', params)
      this.busData.itemList = templateData.itemList || [];
    },
    changeQuestionTotal(item){
      if(!item.catalog){
        this.$message.error("请先选择知识类别");
        return;
      }
      if(!item.question_type){
        this.$message.error("请先选择题型");
        return;
      }
      this.changeQuestionNumber();
    },
    //计算总分
    changeQuestionNumber(){
      this.busData.total_score = 0;
      for(var i = 0; i < this.busData.itemList.length; i++){
        var item = this.busData.itemList[i]

        if(item.catalog && item.question_type && item.score && item.question_number){
          var total_score = item.score * item.question_number
          this.busData.total_score += total_score;
        }
      }
    },
    clearPreData() {
      //清空表单数据
      this.busData.remark = ''
      this.busData.itemList = []
      this.changeQuestionNumber();
    },

    async getCatalogWithQuestion() {
      this.catalogWithQuestion = await this.$http('ihtCatalogService.getCatalogLevel1')
    },

    addOneQuestion() {
      this.busData.itemList.push({
        id: nanoid(),
        examDetails: {}
      })
    },
    removeOneQuestion(id) {
      let index = this.busData.itemList.findIndex(item => item.id === id);
      this.busData.itemList.splice(index, 1);
      this.changeQuestionNumber();
    },
    editExam(){
      if (!this.busData.name){
        return this.$message.error('试卷模板名称不能为空');
      }
      if (!this.busData.time){
        return this.$message.error('考试时长不能为空');
      }
      if (!this.busData.pass_score){
        return this.$message.error('及格分数不能为空');
      }
      var a = 0;
      for (let i = 0; i < this.busData.itemList.length; i++){
        let obj = this.busData.itemList[i]
        if (obj.catalog){

          if(!obj.question_type){
            return this.$message.error('第${i + 1}行问题题型不能为空');
          }

          if(!obj.score){
            return this.$message.error('第${i + 1}行问题分值不能为空');
          }

          if(!obj.question_number){
            return this.$message.error('第${i + 1}行问题数量不能为空');
          }
          a++;
          obj.has_data = true;
        }
      }

      if(a == 0){
        return this.$message.error("试卷模板数据不能为空");
      }

      this.loading = true;

      console.log(this.busData)
      this.$http('ihtExamTemplateService.editExam', this.busData).then(data => {
        this.loading = false;
        this.clearPreData();
        this.$fn.closeWindow();
        this.$fn.search();
        this.$message.success("编辑成功");
      })
    }
  }
}
</script>

<style scoped>
.form-item {
  width: 240px;
}

.product-head span {
  margin-left: 50px;
}

.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.row {
  margin-top: 15px;
  padding: 0;
}

.row .tip {
  color: goldenrod;
  text-align: center;
  font-size: 14px;
}


.tax-amount {
  color: red;
  font-size: 18px;
}

.tax-amount span {
  margin-left: 15px;
}

.exam-remark {
  width: 100%;
  padding-right: 15px;
}

.close {
  position: absolute;
  top: 5px;
  right: 18px;
  font-size: 18px;
  cursor: pointer;
}
</style>